import { createAsyncThunk } from '@reduxjs/toolkit';
import { loginPreCheck } from 'services/authorization/authorization.service';

interface IPayload {
  username: string;
  password: string;
}

export const ThunkLoginPreCheck = createAsyncThunk(
  'authorization/loginPreCheck',
  (payload: IPayload) => loginPreCheck(payload).then(res => res.data),
);
